module.exports = __webpack_public_path__ + "fonts/Calibre-Bold.c76f2c3d.woff";